(ns dre.pages.dictionary.events
  (:require
   [day8.re-frame.tracing :refer-macros [fn-traced]]
   [dre.coll :refer [nn-hash-map]]
   [dre.network :as-alias network]
   [dre.page-util :refer [strip-lang]]
   [dre.utils :refer [stringify-keys-with-namespaces]]
   [dre.util :refer [distinct-case-insensitive]]
   [dre.shared.interface.search.pills :as pills]
   [re-frame.core :as rf]
   [superstructor.re-frame.fetch-fx :as-alias fetch-fx]))

(def db-path :dictionary)

(defn route-params
  ([guid]
   {:guid guid})
  ([query source]
   {:guid "-"
    :query-params (nn-hash-map :query query :source source)})
  ([guid query source]
   {:guid (or guid "-")
    :query-params (nn-hash-map :query query :source source)}))

(defn get-modal-params
  [modal-params]
  (let [term (first (:phrase modal-params))]
    {:params {:query/query (or (:sense term) (:label term) (:pill/query term) (:pill/label term))
              :dict/norm-labels? true
              :dict/labels? true}
     :sense-params {:dict/senses [(or (:sense term) (:label term) (:pill/query term) (:pill/label term))]}
     :pill (:pill modal-params)
     :label (or (:label term) (:pill/label term))}))

(defn get-uri-params
  [query-params route-params]
  (let [guid (:guid route-params)
        {:keys [:query :source]} query-params]
    {:params {:dict/guid guid
              :query/query query
              :query/source source
              :dict/norm-labels? true
              :dict/labels? true}
     :sense-params {:dict/senses [(or query guid source)]}
     :pill nil
     :label nil}))

(defn term-card
  [init-label query canonical-label label-map guid-map terms]
  (let [term (first terms)
        uri (get term :term/uri)]
    (hash-map :terms terms
              :label-map label-map
              :guid-map guid-map
              :entity-fetched? true
              :sense (or (:query/sense query) (:query/query query))
              :canonical-label canonical-label
              :title (or init-label (get term :term/label) uri)
              :id (guid-map uri))))

(defn labels
  [term]
  (mapcat
   strip-lang
   (cons (get term :term/label)
         (get term :term/alts))))

;; events
(rf/reg-event-fx
 ::init
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [query-params route-params modal-params]}]]
  (let [search-params (if modal-params
                        (get-modal-params modal-params)
                        (get-uri-params query-params route-params))]
    {:db {:data {:is-modal? (if modal-params true false)
                 :init-label (:label search-params)}
          :state {:term :loading
                  :sense-details :loading
                  :acronyms :loading}}
     :dispatch-n [[::fetch-term (:params search-params)]
                  [::fetch-sense-details (:sense-params search-params)]
                  (when (:pill search-params)
                    [::fetch-blueprints (:pill search-params)])]})))
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
(rf/reg-event-fx
 ::fetch-term
 [(rf/path db-path) rf/trim-v]
 (fn
   [{db :db} [params]]
   {::network/request [{:endpoint :dictionary/term-similars}
                       {:body (stringify-keys-with-namespaces params)
                        :on-success [::success-fetch-term]
                        :on-failure [::failure-fetch-term]}]}))

(def term-type-blacklist
  #{"http://vocab.drevidence.com/UMLS#C0348080"})

(rf/reg-event-fx
 ::success-fetch-term
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response]}]]
  (let [response-body (:body response)
        label-map (get response-body :dict/label-map)
        guid-map (get response-body :dict/guid-map)
        terms (get response-body :dict/terms)
        query {:query/query (get response-body :query/query)
               :query/sense (get response-body :query/sense)}
        canonical-label (get response-body :sense/canonical-label)
        result (term-card (get-in db [:data :init-label]) query canonical-label label-map guid-map terms)
        uf (fn [terms] (vec (remove (comp term-type-blacklist
                                          #(or (get % "rdf/type")
                                               (get % :rdf/type)))
                                    terms)))
        result (update result :terms uf)
        terms (:terms result)
        labels (distinct (mapcat labels terms))
        next-subclass-event (when (pos? (count terms))
                              [::fetch-subclass terms])]
    {:db (-> db
             (assoc-in [:state :term] :success)
             (assoc-in [:data :term] result))
     :dispatch-n [[::fetch-acronyms labels]
                  next-subclass-event]})))

(rf/reg-event-fx
 ::failure-fetch-term
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response] :as opts}]]
  {:db (assoc-in db [:state :term] :failure)
   :dispatch-n [[:dre.network/default-failure opts]]}))
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
(rf/reg-event-fx
 ::fetch-sense-details
 [(rf/path db-path) rf/trim-v]
 (fn
   [{db :db} [params]]
   {::network/request [{:endpoint :dictionary/senses}
                       {:body (stringify-keys-with-namespaces params)
                        :on-success [::success-fetch-sense-details]
                        :on-failure [::failure-fetch-sense-details]}]}))

(rf/reg-event-fx
 ::success-fetch-sense-details
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response]}]]
  (let []
    {:db (-> db
             (assoc-in [:state :sense-details] :success)
             (assoc-in [:data :sense-details] (first (:dict/sense-details (:body response)))))})))

(rf/reg-event-fx
 ::failure-fetch-sense-details
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response] :as opts}]]
  {:db (assoc-in db [:state :sense-details] :failure)
   :dispatch-n [[:dre.network/default-failure opts]]}))
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
(rf/reg-event-fx
 ::fetch-acronyms
 [(rf/path db-path) rf/trim-v]
 (fn
   [{db :db} [terms]]
   {::network/request [{:endpoint :dictionary/acronyms}
                       {:body (stringify-keys-with-namespaces {:terms (take 200 (distinct-case-insensitive terms))})
                        :on-success [::success-fetch-acronyms]
                        :on-failure [::failure-fetch-acronyms]}]}))

(rf/reg-event-fx
 ::success-fetch-acronyms
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response]}]]
  (let []
    {:db (-> db
             (assoc-in [:state :acronyms] :success)
             (assoc-in [:data :acronyms] (:body response)))})))

(rf/reg-event-fx
 ::failure-fetch-acronyms
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response] :as opts}]]
  {:db (assoc-in db [:state :acronyms] :failure)
   :dispatch-n [[:dre.network/default-failure opts]]}))
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
(rf/reg-event-fx
 ::fetch-subclass
 [(rf/path db-path) rf/trim-v]
 (fn
   [{db :db} [terms]]
   (let [terms (mapv
                (fn [term]
                  (select-keys term [:vocab/uri :term/uri :term/label]))
                terms)]
     {:db (-> db
              (assoc-in [:state :subclass] :loading))
      ::network/request [{:endpoint :dictionary/term-subclass-graph}
                         {:body (stringify-keys-with-namespaces {:query/terms terms})
                          :on-success [::success-fetch-subclass]
                          :on-failure [::failure-fetch-subclass]}]})))

(rf/reg-event-fx
 ::success-fetch-subclass
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response]}]]
  (let []
    {:db (-> db
             (assoc-in [:state :subclass] :success)
             (assoc-in [:data :subclass] (:body response)))})))

(rf/reg-event-fx
 ::failure-fetch-subclass
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response] :as opts}]]
  {:db (assoc-in db [:state :subclass] :failure)
   :dispatch-n [[:dre.network/default-failure opts]]}))
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;
(rf/reg-event-fx
 ::fetch-blueprints
 [(rf/path db-path) rf/trim-v]
 (fn
   [{db :db} [pill]]
   (let [params {:query/blueprints [pill]
                 :dict/pill-details? true}]
     {:db (-> db
              (assoc-in [:state :blueprints] :loading))
      ::network/request [{:endpoint :dictionary/complete-blueprints}
                         {:body (stringify-keys-with-namespaces params)
                          :on-success [::success-fetch-blueprints]
                          :on-failure [::failure-fetch-blueprints]}]})))

(rf/reg-event-fx
 ::success-fetch-blueprints
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response]}]]
  (let []
    {:db (-> db
             (assoc-in [:state :blueprints] :success)
             (assoc-in [:data :blueprints] {:completed-pill
                                            (first (pills/coerce (:query/pills (:body response))))}))})))

(rf/reg-event-fx
 ::failure-fetch-blueprints
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [{:keys [::fetch-fx/response] :as opts}]]
  {:db (assoc-in db [:state :blueprints] :failure)
   :dispatch-n [[:dre.network/default-failure opts]]}))
;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;

(rf/reg-event-fx
 ::set-subclass-height
 [(rf/path db-path) rf/trim-v]
 (fn-traced
  [{db :db} [height]]
  {:db (assoc db :subclass-height height)}))
;; subscriptions
(rf/reg-sub
 ::state
 (fn [db _]
   (db-path db)))

(rf/reg-sub
 ::subclass-height
 :<- [::state]
 (fn [state _]
   (let [data (get state :subclass-height)]
     data)))

(rf/reg-sub
 ::data
 :<- [::state]
 (fn [state _]
   (let [data (get state :data)]
     data)))

(rf/reg-sub
 ::loading?
 :<- [::state]
 (fn [state _]
   (let [data (get state :state {})]
     (or
      (= :loading (:blueprints data))
      (= :loading (:subclass data))
      (= :loading (:term data))
      (= :loading (:sense-details data))
      (= :loading (:acronyms data))))))
